<template>
  <div class="hello">
    
    <h2>{{question}}</h2>
    
    <h3>{{ data[stage] }}</h3>
    <p v-for="ad in adjectives" :key="ad">{{ ad }}</p>
    <p>Press next when you are ready to proceed to the next step.</p>
    <br>

    <div style="width: auto; max-width: 400px; margin: auto; text-align: center;">
      <audio-recorder :pause-recording="callback" :after-recording="callback"/>
      <br>
      <audio v-if="url" :src="url" controls :title="file_name"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: String,
    adjectives: Array[String],
    index: Number,
    total: Number,
    stage: Number
  },
  data() {
    return {
      recording: false,
      url: null,
      data: [
        "For the above topic, provide a 30s response. Use the following helper words to guide you along if necessary",
        "For the same topic, provide another 30s response but don't use the same adjectives",
        "Take a completely opposite stance on the above topic"
      ]
    };
  },
  computed: {
    file_name() {
      let padded_number = "";
      if (this.index < 10) {
        padded_number = `00${this.index + 1}`;
      } else if (this.index < 100) {
        padded_number = `0${this.index + 1}`;
      } else {
        padded_number = `${this.index + 1}`;
      }

      return `utterance-${padded_number}.mp3`;
    }
  },
  methods: {
    toggle_record() {
      this.recording = !this.recording;
    },
    callback(data) {
      console.debug(data);
      if (data && data.url) {
        this.url = data.url; // window.URL.createObjectURL(data.blob);

        // var link = document.createElement("a");
        // link.href = this.url;
        // link.innerHTML = "download here";
        // link.download = `voice_${this.index}.mp3`;
        // // link.style = "display: none";
        // document.body.appendChild(link);
        // link.click();
        // console.log("dine");
        // window.URL.revokeObjectURL(this.url);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h3 {
  margin: 40px 0 0;
}

.ar-records {
  display: none !important;
}

.ar-player {
  display: none !important;
}
</style>
